import { gql } from '@apollo/client';

export const GET_MASTER_DATA_IMPORT_ERRORS = gql(/* GraphQL */ `
    query GetMasterDataImportErrors {
        getMasterDataErrors {
            operationHierarchyErrors
            procurementHierarchyErrors
            productImportErrors
        }
    }
`);
